module.exports = __webpack_public_path__ + "img/5.394c7b4c.png";